module.exports = __webpack_public_path__ + "img/estatua-de-la-libertad.17b32a56.jpeg";